import { RESPONSIVE_QUERIES } from "./responsive-queries";
import { useMediaQuery } from "./useMediaQuery";

// Tailwind xl: desktop layout; useIsDesktop retains its existing md contract.
export const useIsDesktopLayout = (): boolean => {
  return useMediaQuery(RESPONSIVE_QUERIES.desktopLayout);
};
